<mat-form-field (click)="dp.open()" [appearance]="appearance" [class]="fieldClass" [floatLabel]="floatLabel">
    <mat-label>{{ label | translate }}</mat-label>
    <input matInput [value]="displayValue" readonly>
    <input [matDatepicker]="dp" [formControl]="hiddenControl" [min]="minDate" [max]="maxDate" style="display:none"/>
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>

    <mat-datepicker #dp
        startView="year"
        [panelClass]="panelClass"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, dp)">
    </mat-datepicker>
</mat-form-field>
